<template>
  <div class="head">
    <router-view class="content"></router-view>
    <mt-tabbar v-model="selected">
    <router-link :to="'/product?openid='+href" class="mint-tab-item">
          <mt-tab-item id="发现">
            <!-- <img slot="icon"  :src="$store.state.num==3?icon2:icon1" > -->
            <i class="foot-icon foot-prod-icon"></i>
            <span class="font-text">产品</span>
          </mt-tab-item>
    </router-link>
    <!-- <router-link :to="'/order/'+href" class="mint-tab-item">
        <mt-tab-item id="我的">
            <img slot="icon" :src="$store.state.num==4?icon6:icon5" style="width:20px;">
            <span :style="{'color':$store.state.num==4?'#333333':'#bfcbd9'}">工单</span>
        </mt-tab-item>
    </router-link>

 -->
        <!-- <router-link :to="'/teach'" class="mint-tab-item">
          <mt-tab-item id="我的">
              <img slot="icon"  :src="$store.state.num==6?icon7:icon8" style="width:20px;">
              <span :style="{'color':$store.state.num==6?'#333333':'#bfcbd9'}">技术文档</span>
          </mt-tab-item>
        </router-link> -->
    <router-link :to="'/my/'+href" class="mint-tab-item">
        <mt-tab-item id="我的">
            <i class="foot-icon foot-user-icon"></i>
            <span class="font-text">个人中心</span>
        </mt-tab-item>
    </router-link>
    </mt-tabbar>
  </div>
</template>

<script>
import icon1 from "../assets/icon1.png"
import icon2 from "../assets/icon2.png"
import icon3 from "../assets/icon3.png"
import icon4 from "../assets/icon4.png"
import icon5 from "../assets/icon5.png"
import icon6 from "../assets/icon6.png"
import icon7 from "../assets/ji.png"
import icon8 from "../assets/ji1.png"

import cookie from "../js/cookie.js"
export default {
  name: 'app',
  data () {
    return {
      selected:true,
      href:this.$store.state.openid,
      icon1:icon1,icon2:icon2,icon3:icon3,icon4:icon4,icon5:icon5,icon6:icon6,
      icon7:icon7,icon8:icon8,
    }
  },
  created(){
  },
  methods:{

  }
}
</script>
<style lang='scss' type='text/scss'>
.foot-icon{
  display: inline-block;
  width:30px;
  height:30px;
  vertical-align: middle;
  margin:0 auto;
  background-image: url(../assets/foot.png);
  background-position:0 -30px;
  background-repeat: no-repeat;
  background-size:90px 60px;
  transform: scale(0.9);
  &.foot-user-icon{
    width:30px;
    background-position:-60px -30px
  }
  &.foot-prod-icon{
    width:60px;
    background-position: 0 -30px;
  }
}
.font-text{
  color:#666;
  font-size: 14px
}
.router-link-active{
  .foot-user-icon{
    background-position:-60px 0px
  }
  .foot-prod-icon{
    width:60px;
    background-position: 0 0px;
  }
  .font-text{
    color:#004f91
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue